<template>
    <div>
        <el-scrollbar>
            <div v-for="(v, i) in list" :key="v.id">
                <IslandShopRecord
                    :obj="v"
                    @clickEdit="clickEdit"
                    @clickEnable="clickEnable"
                    @clickDisable="clickDisable"
                />
            </div>
        </el-scrollbar>
    </div>
</template>

<script setup>

import IslandShopRecord from "@/components/shopopee/island/islandShopRecord.vue";

const props = defineProps(["list"])
const emits = defineEmits(["clickEdit", "clickEnable", "clickDisable"])

function clickDisable(obj){
    emits("clickDisable", obj)
}

function clickEnable(obj){
    emits("clickEnable", obj)
}

function clickEdit(obj){
    emits("clickEdit", obj)
}

</script>

<style scoped>

</style>